(function () {

  var FIELD_LIMITS = {
    Nombre: 50,
    Apellidos: 50,
    Nacionalidad: 50,
    Frase: 150,
    Fecha: 50
  };

  // Same rule as passport-customizer.js: no emojis in personalization fields.
  var EMOJI_RE = /(?![\u00A9\u00AE\u2122])\p{Extended_Pictographic}|[\u{1F1E6}-\u{1F1FF}\u{1F3FB}-\u{1F3FF}\u{FE0E}\u{FE0F}\u{200D}\u{20E3}\u{E0020}-\u{E007F}]/gu;

  function sanitize(value, maxLength) {
    if (typeof value !== 'string') return '';
    return value
      .replace(/<script[^>]*>.*?<\/script>/gi, '')
      .replace(/<[^>]+>/g, '')
      .replace(EMOJI_RE, '')
      .trim()
      .substring(0, maxLength || 100);
  }

  function getMaxLength(propertyName) {
    var base = propertyName.replace(/\d+$/, '');
    return FIELD_LIMITS[base] || 100;
  }

  // Shopify serializes file upload properties as objects {url, name, type, size}.
  // Normalize them to plain strings so /cart/change.js accepts them.
  function normalizePropertyValue(value) {
    if (value === null || value === undefined) return '';
    if (typeof value === 'object' && value.url) return value.url;
    return String(value);
  }

  function getContainerContext(container) {
    var editBtns = container.querySelectorAll('.cart-pef__edit-trigger');
    var actionBar = container.querySelector('.cart-pef__action-bar');
    console.log("action", actionBar);
    return { editBtns: editBtns, actionBar: actionBar };
  }

  function enterEditMode(container, editBtns, actionBar) {
    container.querySelectorAll('details.cart-item-card__passport').forEach(function (d) {
      d.open = true;
    });
    container.querySelectorAll('.cart-pef__view').forEach(function (el) {
      el.classList.add('cart-pef__hidden');
    });
    container.querySelectorAll('.cart-pef__edit').forEach(function (el) {
      el.classList.remove('cart-pef__hidden');
    });
    container.querySelectorAll('.cart-item-card__passport-header-actions').forEach(function (el) {
      el.classList.remove('cart-pef__hidden');
    });
    if (editBtns) editBtns.forEach(function (b) { b.classList.add('cart-pef__hidden'); });
    if (actionBar) actionBar.classList.remove('cart-pef__hidden');
    clearError(container);
  }

  function exitEditMode(container, editBtns, actionBar) {
    container.querySelectorAll('.cart-pef__input, .cart-pef__select').forEach(function (el) {
      if (el.dataset.original !== undefined) {
        el.value = el.dataset.original;
      }
    });
    container.querySelectorAll('.cart-pef__view').forEach(function (el) {
      el.classList.remove('cart-pef__hidden');
    });
    container.querySelectorAll('.cart-pef__edit').forEach(function (el) {
      el.classList.add('cart-pef__hidden');
    });
    container.querySelectorAll('.cart-item-card__passport-header-actions').forEach(function (el) {
      el.classList.add('cart-pef__hidden');
    });
    if (editBtns) editBtns.forEach(function (b) { b.classList.remove('cart-pef__hidden'); });
    if (actionBar) actionBar.classList.add('cart-pef__hidden');
    clearError(container);
  }

  function storeOriginalValues(container) {
    container.querySelectorAll('.cart-pef__input, .cart-pef__select').forEach(function (el) {
      el.dataset.original = el.value;
    });
  }

  function showError(container, message) {
    var errorEl = container.querySelector('.cart-pef__error');
    if (errorEl) errorEl.textContent = message;
  }

  function clearError(container) {
    var errorEl = container.querySelector('.cart-pef__error');
    if (errorEl) errorEl.textContent = '';
  }

  function setSaving(container, actionBar, isSaving) {
    var saveBtn = container.querySelector('.cart-pef__save-trigger');
    var cancelBtn = container.querySelector('.cart-pef__cancel-trigger');
    if (saveBtn) {
      saveBtn.disabled = isSaving;
      saveBtn.textContent = isSaving ? 'Guardando...' : 'Guardar';
    }
    if (cancelBtn) cancelBtn.disabled = isSaving;
  }

  function buildUpdatedProperties(container) {
    var existingPropsRaw = container.dataset.itemProperties || '{}';
    var properties = {};
    try {
      var parsed = JSON.parse(existingPropsRaw);
      if (Array.isArray(parsed)) {
        // Shopify Liquid serializes item.properties as [[key, value], ...] pairs
        parsed.forEach(function (pair) {
          if (Array.isArray(pair) && pair.length >= 2) {
            properties[pair[0]] = normalizePropertyValue(pair[1]);
          }
        });
      } else {
        Object.keys(parsed).forEach(function (key) {
          properties[key] = normalizePropertyValue(parsed[key]);
        });
      }
    } catch (e) {
      properties = {};
    }

    // Read image URLs directly from the DOM — more reliable than JSON serialization
    container.querySelectorAll('img[data-property]').forEach(function (img) {
      var propertyName = img.dataset.property;
      if (propertyName && img.src) {
        properties[propertyName] = img.src;
      }
    });

    // Override text/select fields with sanitized edited values
    container.querySelectorAll('.cart-pef__input, .cart-pef__select').forEach(function (el) {
      var propertyName = el.dataset.property;
      if (!propertyName) return;
      properties[propertyName] = sanitize(el.value, getMaxLength(propertyName));
    });

    // A Compact pack ships one shared UV flashlight, so cart-drawer.liquid renders
    // a single colour control for the whole line item. Fan that one value back out
    // to every ColorN, otherwise passports keep the colours they were added with
    // and the order goes to fulfilment with mixed colours (order #27340).
    var compactColorEl = container.querySelector('[data-compact-color="true"]');
    if (compactColorEl) {
      var compactColor = sanitize(compactColorEl.value, getMaxLength('Color'));
      Object.keys(properties).forEach(function (key) {
        if (/^Color\d+$/.test(key)) properties[key] = compactColor;
      });
    }

    return properties;
  }

  function updateViewValues(container, updatedProperties) {
    for (var i = 1; i <= 25; i++) {
      var nombreVal = updatedProperties['Nombre' + i] || '';
      var apellidosVal = updatedProperties['Apellidos' + i] || '';
      var fullName = (nombreVal + ' ' + apellidosVal).trim() || '-';

      var nombreInput = container.querySelector('[data-property="Nombre' + i + '"]');
      if (nombreInput) {
        var fieldEl = nombreInput.closest('.cart-item-card__field');
        if (fieldEl) {
          var viewSpan = fieldEl.querySelector('.cart-pef__view');
          if (viewSpan) viewSpan.textContent = fullName;
        }
      }

      ['Nacionalidad', 'Frase', 'Fecha', 'Modalidad', 'Color'].forEach(function (field) {
        var input = container.querySelector('[data-property="' + field + i + '"]');
        if (!input) return;
        var fieldEl = input.closest('.cart-item-card__field');
        if (!fieldEl) return;
        var viewSpan = fieldEl.querySelector('.cart-pef__view');
        if (!viewSpan) return;
        var newVal = updatedProperties[field + i] || '';
        if (field === 'Frase') {
          viewSpan.textContent = newVal ? '"' + newVal + '"' : '-';
        } else {
          viewSpan.textContent = newVal || '-';
        }
      });
    }

    // Keep stored properties in sync for subsequent edits
    container.dataset.itemProperties = JSON.stringify(updatedProperties);
    container.querySelectorAll('.cart-pef__input, .cart-pef__select').forEach(function (el) {
      el.dataset.original = el.value;
    });
  }

  // Reads the quantity from the live cart; falls back to the value rendered in
  // the drawer. Never returns less than 1, so an edit can't remove the line.
  async function getLineQuantity(container, itemLine) {
    try {
      var res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (res.ok) {
        var cart = await res.json();
        var item = cart.items && cart.items[itemLine - 1];
        if (item && item.quantity > 0) return item.quantity;
      }
    } catch (e) {}
    var rendered = parseInt(container.dataset.itemQuantity, 10);
    return rendered > 0 ? rendered : 1;
  }

  async function savePassportEdit(container, editBtns, actionBar) {
    var itemLine = parseInt(container.dataset.itemLine, 10);
    if (!itemLine) return;

    setSaving(container, actionBar, true);
    clearError(container);

    var properties = buildUpdatedProperties(container);

    try {
      // /cart/change.js resets the line to quantity 1 when only properties are
      // sent, so a 2-passport PAREJA line (or a FAMILIA line) dropped to 1 unit
      // after an edit. Always send the line's current quantity with the change.
      var quantity = await getLineQuantity(container, itemLine);

      var response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: itemLine, quantity: quantity, properties: properties })
      });

      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }

      var cart = await response.json();
      var updatedLine = cart && cart.items && cart.items[itemLine - 1];
      if (updatedLine) container.dataset.itemQuantity = updatedLine.quantity;
      updateViewValues(container, properties);
      exitEditMode(container, editBtns, actionBar);
    } catch (e) {
      showError(container, 'Error al guardar. Por favor, inténtalo de nuevo.');
    } finally {
      setSaving(container, actionBar, false);
    }
  }

  // Event delegation on document — works for both the page cart and the drawer
  // after AJAX re-renders (drawer replaces innerHTML, which destroys direct listeners).
  document.addEventListener('click', function (e) {
    // Edit trigger
    var editTrigger = e.target.closest('.cart-pef__edit-trigger');
    if (editTrigger) {
      e.preventDefault();
      var card = editTrigger.closest('.cart-item');
      var container = card ? card.querySelector('[data-passport-item]') : null;
      if (!container) return;
      storeOriginalValues(container);
      var ctx = getContainerContext(container);
      enterEditMode(container, ctx.editBtns, ctx.actionBar);
      return;
    }

    // Cancel trigger
    var cancelTrigger = e.target.closest('.cart-pef__cancel-trigger');
    if (cancelTrigger) {
      var container = cancelTrigger.closest('[data-passport-item]');
      if (!container) return;
      var ctx = getContainerContext(container);
      exitEditMode(container, ctx.editBtns, ctx.actionBar);
      return;
    }

    // Save trigger
    var saveTrigger = e.target.closest('.cart-pef__save-trigger');
    if (saveTrigger) {
      var container = saveTrigger.closest('[data-passport-item]');
      if (!container) return;
      var ctx = getContainerContext(container);
      savePassportEdit(container, ctx.editBtns, ctx.actionBar);
    }
  });

})();